import Repository from './Repository'

const resource = '/twilio'

export default {
  getCallCenterStatistics (hiddenLoad = false) {
    return Repository.get(`${resource}/call-center-statistics`, { number: Math.random() }, {}, hiddenLoad)
  },
  setErrors (e) {
    const errorCode = e.response ? e.response.status : 500
    return {
      status: false,
      errorCode: errorCode,
      data: e.response ? e.response.data : 'error',
      error: e
    }
  },
  catchError (e) {
    return e.response ? e.response.data : 'error'
  }
}
